export default __webpack_public_path__ + "static/media/s2c2.44bc1166.jpeg";